import {
  sumBy,
  subtract,
} from './math.js'

export const getPayingAvailable = (partials = [], payingCost = 0) => {
  const partialCost = sumBy(partials, 'cost')
  const availableCost = subtract(payingCost, partialCost)
  return availableCost
}



// WEBPACK FOOTER //
// ./src/function/paying.js